/**
 * AD-1961: Chase Query "select all" caps for the Bulk Change hand-off, chosen by the server flag
 * `EnableChaseQuerySelectAll50k`. The grid passes the cap it showed to Bulk Change as `selectAllLimit`.
 */

/** Flag OFF — original behaviour (`chase/query`). */
export const SELECT_ALL_LIMIT_LEGACY = 5000;

/** Flag ON — ids-only `chase/query/ids` endpoint. */
export const SELECT_ALL_LIMIT_HIGH_VOLUME = 50000;
